// FIXME: Podedit ci pouzit interne v ramci kompozice PopOver
import { node } from "~/util/dom";

// TODO: bude-li nekdy treba dodat i moznost vlevo a vpravo, tak neni problem
export enum ETooltipPosition {
	BOTTOM,
	TOP,
}

export enum ETooltipFlow {
	START,
	CENTER,
	END,
	ARROW_START,
	ARROW_END,
}

type TooltipMargin = [top: number, right: number, bottom: number, left: number];

interface ITooltipProps {
	trigger?: HTMLElement | SVGElement;
	triggerEventType?: "click" | "pointerenter";
	anchor: HTMLElement | SVGElement;
	position?: ETooltipPosition;
	flow?: ETooltipFlow;
	margin?: TooltipMargin;
	offset?: TooltipMargin;
	content: HTMLElement | DocumentFragment;
	width?: number;
	arrow?: boolean;
	className?: string;
	showTimeout?: number;
	hideTimeout?: number;
	onShow?: () => void;
	onHide?: () => void;
}

const ARROW_HEIGHT = 11;
const ARROW_WIDTH = 17;
const ARROW_SVG = `<svg width="${ARROW_WIDTH}" height="${ARROW_HEIGHT}" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg" class="ui-tooltip__arrow ui-tooltip--inert" role="presentation"><path d="M0.5 11L6.8359 1.49615C7.62754 0.308684 9.37246 0.308685 10.1641 1.49615L16.5 11H0.5Z" /></svg>`;
const HIDE_TIMEOUT = 150;
const DEFAULT_PROPS: ITooltipProps = {
	trigger: null,
	triggerEventType: "pointerenter",
	anchor: null,
	position: ETooltipPosition.BOTTOM,
	flow: ETooltipFlow.CENTER,
	margin: [0, 0, 0, 0],
	offset: [0, 0, 0, 0],
	content: null,
	width: 0,
	arrow: true,
	className: "",
	showTimeout: 0,
	hideTimeout: HIDE_TIMEOUT,
};

export default class Tooltip {
	#tooltip: HTMLDivElement;

	#arrow: HTMLElement;

	#showTimeout: number;

	#hideTimeout: number;

	#props: ITooltipProps;

	#isVisible: boolean;

	#isInert: boolean;

	constructor(props: ITooltipProps) {
		this.#props = {
			...DEFAULT_PROPS,
			...props,
		};
		this.#showTimeout = 0;
		this.#hideTimeout = 0;

		this.#isVisible = false;

		this.#isInert = this.#props.triggerEventType === "pointerenter" && (typeof typeof this.#props.onHide === "function" || typeof this.#props.onShow === "function");

		this.#tooltip = node("div", { className: `ui-tooltip ${this.#props.className}${this.#isInert ? " ui-tooltip--inert" : ""}` });
		this.#tooltip.appendChild(this.#props.content);

		(this.#props.trigger || this.#props.anchor).addEventListener("pointerenter", this);
		(this.#props.trigger || this.#props.anchor).addEventListener("pointerleave", this);
		this.#tooltip.addEventListener("pointerenter", this);
		this.#tooltip.addEventListener("pointerleave", this);
		document.body.addEventListener("click", this);

		const parser = new DOMParser();
		const doc = parser.parseFromString(ARROW_SVG, "image/svg+xml");

		this.#arrow = doc.firstChild as HTMLElement;
	}

	destroy() {
		this.#clearShowTimeout();
		(this.#props.trigger || this.#props.anchor).removeEventListener("pointerenter", this);
		(this.#props.trigger || this.#props.anchor).removeEventListener("pointerleave", this);
		this.#tooltip.removeEventListener("pointerenter", this);
		this.#tooltip.removeEventListener("pointerleave", this);
		document.body.removeEventListener("click", this);
	}

	handleEvent(event: PointerEvent) {
		if (this.#props.triggerEventType === "pointerenter") {
			switch (event.type) {
				case "pointerenter":
					if (event.target === (this.#props.trigger || this.#props.anchor)) {
						this.#showTooltipCover();
					}

					if (this.#hideTimeout) {
						window.clearTimeout(this.#hideTimeout);
						this.#hideTimeout = 0;
					}

					break;

				case "pointerleave":
					this.#hideTimeout = window.setTimeout(() => {
						this.hide();
					}, this.#props.hideTimeout);
					break;

				default:
					//
			}
		} else if (this.#props.triggerEventType === "click") {
			if (event.type === "click") {
				if ((event.target === this.#props.trigger || this.#props.trigger.contains(event.target as HTMLElement)) && this.#isVisible === false) {
					this.#showTooltipCover();
				} else if (this.#isVisible === true) {
					this.hide();
				}
			}
		}
	}

	hide() {
		this.#clearShowTimeout();

		if (this.#isVisible) {
			this.#tooltip.remove();
			this.#arrow.remove();
			this.#isVisible = false;
			if (this.#props.triggerEventType === "click") {
				this.#props.trigger.classList.remove("triggered");
			}
			if (typeof this.#props.onHide === "function") {
				this.#props.onHide();
			}
		}
	}

	#placeArrow(anchorRect: DOMRect, position: ETooltipPosition) {
		let cssArrow: Partial<CSSStyleDeclaration> = null;
		const left = `${Math.round(anchorRect.left - (ARROW_WIDTH / 2) + (anchorRect.width / 2))}px`;

		switch (position) {
			case ETooltipPosition.BOTTOM:
				this.#arrow.style.removeProperty("bottom");
				this.#arrow.style.removeProperty("transform");
				cssArrow = {
					left,
					top: `${anchorRect.top + window.scrollY + anchorRect.height + this.#props.offset[2]}px`,
				};
				break;

			case ETooltipPosition.TOP:
				this.#arrow.style.removeProperty("top");
				cssArrow = {
					left,
					bottom: `${window.innerHeight - anchorRect.top + window.scrollY + this.#props.offset[0]}px`,
					transform: `rotate(180deg)`,
				};
				break;

			default:
				//
		}

		Object.assign(this.#arrow.style, cssArrow);
	}

	#placeTooltip(anchorRect: DOMRect, position: ETooltipPosition) {
		let cssTooltip: Partial<CSSStyleDeclaration> = null;

		switch (position) {
			case ETooltipPosition.BOTTOM:
				this.#tooltip.style.removeProperty("bottom");
				cssTooltip = {
					top: `${anchorRect.top + window.scrollY + anchorRect.height + (this.#props.arrow ? ARROW_HEIGHT : 0) + this.#props.offset[2]}px`,
					width: this.#props.width > 0 ? `${this.#props.width}px` : "auto",
				};
				break;

			case ETooltipPosition.TOP:
				this.#tooltip.style.removeProperty("top");
				cssTooltip = {
					bottom: `${window.innerHeight - anchorRect.top + window.scrollY + (this.#props.arrow ? ARROW_HEIGHT : 0) + this.#props.offset[0]}px`,
					width: this.#props.width > 0 ? `${this.#props.width}px` : "auto",
				};
				break;

			default:
				//
		}

		Object.assign(this.#tooltip.style, cssTooltip);
	}

	#showTooltipCover() {
		this.#clearShowTimeout();

		if (this.#props.showTimeout > 0) {
			this.#showTimeout = window.setTimeout(() => {
				this.#showTimeout = 0;
				this.#showTooltip();
			}, this.#props.showTimeout);
		} else {
			this.#showTooltip();
		}
	}

	#clearShowTimeout() {
		if (this.#showTimeout) {
			clearTimeout(this.#showTimeout);
			this.#showTimeout = 0;
		}
	}

	#showTooltip() {
		if (!this.#isVisible) {
			let position = this.#props.position;
			const anchorRect = this.#props.anchor.getBoundingClientRect();
			const arrowLeft = Math.round(anchorRect.left - (ARROW_WIDTH / 2) + (anchorRect.width / 2));

			// do zacatku je tooltip neviditelny, protoze mozna bude menit pozici a tedy nechceme, aby ho uzivatel videl na spatnem miste driv
			this.#tooltip.classList.add("ui-tooltip--invisible");
			document.body.appendChild(this.#tooltip);
			this.#placeTooltip(anchorRect, position);

			let tooltipRect = this.#tooltip.getBoundingClientRect();

			// uvodni napozicovani - optimisticky to dame tam, kam to patri dle zadani
			switch (this.#props.flow) {
				case ETooltipFlow.CENTER: {
					// spocitame levou/pravou, protoze zname sirku predem
					let leftNumber = Math.round(anchorRect.left - (tooltipRect.width / 2) + (anchorRect.width / 2));
					// precniva doprava? tak odsoupneme od praveho okraje

					leftNumber = leftNumber + tooltipRect.width > window.innerWidth - this.#props.margin[1] ? window.innerWidth - this.#props.margin[1] - tooltipRect.width : leftNumber;
					// precniva doleva? tak odsoupneme od leveho a tim padem muze teoreticky precnivat zase vpravo, ale to uz je smula
					leftNumber = leftNumber < this.#props.margin[3] ? this.#props.margin[3] : leftNumber;
					const left = `${leftNumber}px`;

					this.#tooltip.style.left = left;
				} break;

				case ETooltipFlow.START:
					this.#tooltip.style.left = `${anchorRect.left - this.#props.margin[3]}px`;
					break;

				case ETooltipFlow.END:
					this.#tooltip.style.right = `${window.innerWidth - anchorRect.right + this.#props.margin[1]}px`;
					break;

				default:
					//
			}

			tooltipRect = this.#tooltip.getBoundingClientRect();

			// korekce na druhou stranu, pokud se na tuhle nevejde (tedy pokud zkusime prohodit top a bottom, pripadne left a right)
			switch (position) {
				case ETooltipPosition.BOTTOM:
					if (tooltipRect.bottom > window.innerHeight - this.#props.margin[2]) {
						position = ETooltipPosition.TOP;
						this.#placeTooltip(anchorRect, position);
					}
					break;

				case ETooltipPosition.TOP:
					if (tooltipRect.top < this.#props.margin[0]) {
						position = ETooltipPosition.BOTTOM;
						this.#placeTooltip(anchorRect, position);
					}
					break;

				default:
					//
			}

			switch (this.#props.flow) {
				case ETooltipFlow.ARROW_START:
					this.#tooltip.style.left = `${arrowLeft - 7}px`;
					break;

				case ETooltipFlow.ARROW_END:
					this.#tooltip.style.left =`${arrowLeft + ARROW_WIDTH - tooltipRect.width + 7}px`;
					break;

				default:
					//
			}

			// po korekci umistime sipecku
			if (this.#props.arrow) {
				this.#placeArrow(anchorRect, position);
				document.body.appendChild(this.#arrow);
			}

			// a ukazeme
			this.#tooltip.classList.remove("ui-tooltip--invisible");
			this.#isVisible = true;
			if (this.#props.triggerEventType === "click") {
				this.#props.trigger.classList.add("triggered");
			}
			if (typeof this.#props.onShow === "function") {
				this.#props.onShow();
			}
		}
	}
}
